export const SUPER_ADMIN_PROJECTS = [
  {
    id: "wolsung-youth-2026",
    organization: "월성복지관",
    name: "2026 청년도전지원사업",
    code: "WS-YOUTH-2026",
  },
  {
    id: "somang-mental-health",
    organization: "대구소방안전본부",
    name: "대구소방 정신건강 지원 사업",
    code: "FIRE2026",
  },
  {
    id: "daegu-counseling",
    organization: "대구한의대학교",
    name: "학생 상담 센터",
    code: "GROW2026",
  },
  {
    id: "garam-inquiry",
    organization: "가람마인드",
    name: "말랑포켓 문의사항",
    code: "GARAM-INQUIRY",
  },
  {
    id: "garam-middle-house",
    organization: "가람마인드",
    name: "중간집",
    code: "GARAM-MIDDLE-HOUSE",
  },
];

export const getProjectsForAdmin = (me) => {
  if (me?.code === "ADMIN-MASTER-KEY") return SUPER_ADMIN_PROJECTS;

  const matchedProject = SUPER_ADMIN_PROJECTS.find((project) => project.code === me?.code);
  if (matchedProject) return [matchedProject];

  return [
    {
      id: me?.code || "sample-project",
      organization: me?.organization || "소속",
      name: me?.level === 9 && me?.code?.startsWith("ADMIN-TEST") ? "샘플 화면" : "소속 관리",
      code: me?.code || "SAMPLE",
    },
  ];
};

export const getDefaultProject = (me) => getProjectsForAdmin(me)[0] ?? null;
